import { Form } from "antd";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

import type { ContractEntity } from "src/app/features/Contract/types/ContractEntity";
import { Checkbox, SelectDynamic, TextInput } from "../../../../../components/Form/formComponents";
import { NumberInput } from "../../../../../components/Form/formComponents/Number/NumberInput";
import type { SearchFormProps } from "../../../../../components/Form/types/types";
import {
    acquirerProviderSelectConfig,
    acquirerTypeSelectConfig,
    appProfileListSelectConfig,
    contractBaseSelectConfig,
    contractProfileSelectConfig,
    siteSelectConfig,
    statusSelectorConfig,
} from "../../../../../components/SearchForm/FormSearchUtils";
import { SearchForm } from "../../../../../components/SearchForm/SearchForm";

export const ContractSearchForm: FC<SearchFormProps<ContractEntity>> = ({ searchCallback }) => {
    const { t } = useTranslation();

    return (
        <SearchForm searchCallback={searchCallback}>
            <Form.Item label={t("contractSearchForm.criteriaBadges.id")} name="id">
                <NumberInput name="id" readOnly={false} />
            </Form.Item>
            <Form.Item name="acquirer" label={t("contractSearchForm.criteriaBadges.provider")}>
                <SelectDynamic
                    name="acquirer"
                    label={t("contractSearchForm.criteriaBadges.provider")}
                    fieldConfig={acquirerProviderSelectConfig}
                />
            </Form.Item>
            <Form.Item label={t("contractSearchForm.criteriaBadges.contractNumber")} name="contractNumber">
                <TextInput name="contractNumber" />
            </Form.Item>
            <Form.Item name="siteId" label={t("contractSearchForm.criteriaBadges.siteId")}>
                <SelectDynamic name="siteId" label={t("contractSearchForm.criteriaBadges.siteId")} fieldConfig={siteSelectConfig} />
            </Form.Item>

            <Form.Item name="appProfileListId" label={t("contractSearchForm.criteriaBadges.appProfileId")}>
                <SelectDynamic
                    name="appProfileListId"
                    label={t("contractSearchForm.criteriaBadges.appProfileId")}
                    fieldConfig={appProfileListSelectConfig}
                />
            </Form.Item>
            <Form.Item name="acquirerType" label={t("contractSearchForm.criteriaBadges.providerType")}>
                <SelectDynamic
                    name="acquirerType"
                    label={t("contractSearchForm.criteriaBadges.providerType")}
                    fieldConfig={acquirerTypeSelectConfig}
                />
            </Form.Item>
            <Form.Item name="contractDiscriminator" label={t("contractSearchForm.criteriaBadges.virtualDiscriminator")}>
                <SelectDynamic
                    name="virtualDiscriminator"
                    label={t("contractSearchForm.criteriaBadges.virtualDiscriminator")}
                    fieldConfig={contractBaseSelectConfig}
                />
            </Form.Item>
            <Form.Item label={t("contractSearchForm.criteriaBadges.active")} name="active">
                <SelectDynamic name="active" label={t("form.status")} value="false" fieldConfig={statusSelectorConfig} />
            </Form.Item>
            <Form.Item label={t("contractSearchForm.criteriaBadges.archived")} name="archived" valuePropName="checked">
                <Checkbox name="archived" label="" readOnly={false} defaultChecked={false} />
            </Form.Item>
            <Form.Item name="contractProfileId" label={t("contractCreateForm.contractProfile")}>
                <SelectDynamic
                    name="contractProfileId"
                    label={t("contractCreateForm.contractProfile")}
                    fieldConfig={contractProfileSelectConfig}
                />
            </Form.Item>
        </SearchForm>
    );
};
